import ApiService from './ApiService';

class ExportService extends ApiService {
    constructor() {
        super();

        this._locale = 'ru';
        this._attributesValuesUrl = '/attributes/export';
        this._buyersUrl = '/users/export/buyers';
        this._newUsersUrl = '/users/export/new';
        this._productsUrl = '/products/export';
        this._ordersUrl = '/orders/export';
    }

    attributesValues(params) {
        return this._export(this._attributesValuesUrl, params);
    }

    buyers(params) {
        return this._export(this._buyersUrl, params);
    }

    newUsers(params) {
        return this._export(this._newUsersUrl, params);
    }

    products(params) {
        return this._export(this._productsUrl, params);
    }

    orders(params) {
        return this._export(this._ordersUrl, params);
    }

    _export(url, params) {
        const query = new URLSearchParams();
        query.append('IDs', JSON.stringify(params));
        window.open(this.getApiPrefix() + `${url}?${query.toString()}`);
    }
}

const service = new ExportService();

export default service;
